/* eslint-disable */
export default {
  businessApiUrl: "https://estatea.zyzhkjbj.com/",
  isDemo: true,
  // apiUrl: 'http://localhost:8086',
  authBaseUrl: 'https://estatea.zyzhkjbj.com/prod-api',
  businessBaseUrl: 'https://estatea.zyzhkjbj.com/prod-api/estate',
  staticBaseUrl: 'https://govern.zyzhkjbj.com',
};
